
export class ChannelMask {
  constructor(
    private readonly channels: Map<string, boolean> = new Map<string, boolean>(),
  ) { }

  isOn(channel: string): boolean {
    return this.channels.get(channel) === true;
  }

  change(channel: string, on: boolean): void {
    this.channels.set(channel, on);
  }

  clearAll(): void {
    this.channels.clear();
  }

  changeAll(channels: Map<string, boolean>): void {
    this.channels.clear();

    for(const [key, value] of channels) {
      this.channels.set(key, value);
    }
  }
}
